import { useEffect, useRef } from "react";
import { useProjectDataStore } from "stores/projectStore";
import { useChangeProject } from "./useChangeProject";

export const useRestoreProject = () => {
  const projectId = useProjectDataStore((state) => state.projectId);
  const projectName = useProjectDataStore((state) => state.projectName);
  const projectIdRef = useRef(projectId);
  const projectNameRef = useRef(projectName);
  const changeProject = useChangeProject();

  useEffect(() => {
    const url = new URL(window.location.href);
    if (projectIdRef.current && projectNameRef.current) {
      url.searchParams.set("originalProjectId", projectIdRef.current);
      url.searchParams.set("originalProjectName", projectNameRef.current);
      window.history.pushState({}, "", url.toString());
    }

    return () => {
      const newUrl = new URL(window.location.href);
      const originalProjectId = newUrl.searchParams.get("originalProjectId");
      const originalProjectName = newUrl.searchParams.get(
        "originalProjectName",
      );
      if (originalProjectId && originalProjectName) {
        newUrl.searchParams.delete("originalProjectName");
      }
      if (originalProjectId) {
        newUrl.searchParams.delete("originalProjectId");
      }
      window.history.pushState({}, "", newUrl.toString());
      if (originalProjectId) {
        changeProject(originalProjectId);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
